import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FsMultiDragDrop {
  private _allSelectedElements: NodeListOf<Element>;

  constructor() {}

  public addToMultiSelect(item: HTMLElement): void {
    if (!item.className.includes('selectedMultiDragDrop')) {
      item.className += ' selectedMultiDragDrop';
    } else {
      item.classList.remove('selectedMultiDragDrop');
    }
    const allElements = document.querySelectorAll('.selectedMultiDragDrop');
    this._allSelectedElements = allElements;
  }

  public dragReleased(): string[] {
    const ids: string[] = [];
    if (this._allSelectedElements) {
      this._allSelectedElements.forEach((element) => {
        if (element.id.length) {
          ids.push(element.id);
          element.classList.remove('.selectedMultiDragDrop');
        }
      });
    }

    if (ids.length) {
      return ids;
    }

    return [];
  }
}
